import { useState } from "react";
import { useTasks } from "../hooks/useTasks";
import { useAuth } from "../contexts/AuthContext";
import Checkmark from "./Checkmark";
import TaskModal from "./TaskModal";

export default function TodayCard() {
  const today = new Date();
  const { isDemoMode, user } = useAuth();
  const { tasks, addTask, removeTask, toggleTask } = useTasks(
    today,
    isDemoMode,
    user?.uid
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const completedCount = tasks.filter((t) => t.completed).length;
  const progress =
    tasks.length > 0 ? Math.round((completedCount / tasks.length) * 100) : 0;

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className="max-w-full lg:max-w-2xl bg-[#202020] rounded-3xl px-6 pt-6 pb-0 cursor-pointer hover:bg-gray-750 transition-colors shadow-[9px_9px_15px_rgba(0,0,0,0.4)] min-h-[300px] flex flex-col"
      >
        <div className="bg-amber-600 rounded-t-3xl -m-6 mb-4 p-4">
          <h2 className="text-white text-xl font-bold text-center uppercase">
            Today
          </h2>
        </div>

        <div className="space-y-3 flex-grow overflow-auto">
          {tasks.length === 0 ? (
            <p className="text-gray-400 text-center py-8">No tasks for today</p>
          ) : (
            tasks.map((task) => (
              <div
                key={task.id}
                className="flex items-center justify-between gap-3 max-w-[80%] mx-auto"
              >
                <span
                  className={`text-white ${
                    task.completed ? "line-through text-gray-500" : ""
                  }`}
                >
                  {task.text}
                </span>
                <Checkmark
                  completed={task.completed}
                  onToggle={(e) => {
                    e.stopPropagation();
                    toggleTask(task.id, task.completed);
                  }}
                />
              </div>
            ))
          )}
        </div>

        <div className="mt-auto pt-6 mb-6 flex items-center justify-center">
          <div className="relative w-28 h-28">
            <svg
              className="transform -rotate-90 w-28 h-28"
              viewBox="0 0 110 110"
            >
              <circle
                cx="55"
                cy="55"
                r="45"
                stroke="#a46e1d"
                strokeWidth="17"
                fill="transparent"
              />
              <circle
                cx="55"
                cy="55"
                r="45"
                stroke="#3b82f6"
                strokeWidth="17"
                fill="transparent"
                strokeDasharray={`${2 * Math.PI * 45}`}
                strokeDashoffset={`${2 * Math.PI * 45 * (1 - progress / 100)}`}
                className="transition-all duration-300"
                strokeLinecap="round"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-white font-bold text-lg">{progress}%</span>
            </div>
          </div>
        </div>
      </div>

      <TaskModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedDate={today}
        tasks={tasks}
        onAddTask={addTask}
        onRemoveTask={removeTask}
        onToggleTask={toggleTask}
      />
    </>
  );
}
